import { Chip } from "@mui/material"
export const COLUMNSTRAYECTORIAS = [
    {
        header: 'Tipo de trayectoria',
        accessorKey: 'new_tipodetrayectoria',
        // Cell: ({ cell }) => <strong>{cell.getValue()}</strong>
        Cell: ({ cell }) => {
            switch (cell.getValue()) {
                case "Nivel Superior Universitario y/o Posgrado":
                    return <Chip label="Nivel Superior Universitario y/o Posgrado" sx={{ fontWeight: "bold" }} color="success" variant="outlined" />
                case "Gestión Académica":
                    return <Chip label="Gestión Académica" sx={{ fontWeight: "bold" }} color="warning" variant="outlined" />
                case "Desempeño no Académico":
                    return <Chip label="Desempeño no Académico" sx={{ fontWeight: "bold" }} color="error" variant="outlined" />
                case "I+D":
                    return <Chip label="I+D" sx={{ fontWeight: "bold" }} color="info" variant="outlined" />
            }
        },
    },
    {
        header: 'Fecha de inicio',
        accessorKey: 'new_fechadeinicio',
        Cell: ({ cell }) => <strong>{cell.getValue()}</strong>
    },
    {
        header: 'Fecha de finalización',
        accessorKey: 'new_fechadefinalizacin',
        Cell: ({ cell }) => <strong>{cell.getValue()}</strong>
    },
    {
        header: 'Institución académica',
        accessorKey: '_new_institucinacadmica_value',
        Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
    },
    {
        header: 'Unidad académica',
        accessorKey: 'new_unidadacadmica',
        Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
    },
    {
        header: 'Cargo',
        accessorKey: 'new_cargo',
        Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
    },
    {
        header: 'Duración del cursado',
        accessorKey: 'new_duracindelcursado',
        Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
    },
    {
        header: 'Dedicación semanal',
        accessorKey: 'new_dedicacinsemanal',
        Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
    },
    {
        header: 'Designación',
        accessorKey: 'new_designacin',
        Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
    },
]